module.exports = __webpack_public_path__ + "static/media/ninth_newpaper_plant.ac49520d.mp4";